import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "display-4" }, "Search results", -1)
const _hoisted_3 = { class: "ms-2 fs-4" }
const _hoisted_4 = { class: "card mt-2" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "col-lg-3 col-md-4 col-sm-6 mb-4" }
const _hoisted_8 = {
  key: 0,
  class: "card"
}
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = {
  key: 2,
  class: "card"
}
const _hoisted_14 = { class: "card-body d-flex flex-column" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = { class: "text-muted me-1" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "d-flex align-items-center mt-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_user_link = _resolveComponent("user-link")
  const _component_time_ago = _resolveComponent("time-ago")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], {
      title: 'Search: ' + $setup.opts.query
    }, null, 8, ["title"]),
    _createVNode($setup["MetaTag"], {
      name: "robots",
      content: "noindex"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, "for «" + _toDisplayString($setup.opts.query) + "»", 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["SearchOptions"], {
              opts: $setup.opts,
              sort: $setup.sort,
              "onUpdate:sort": _cache[0] || (_cache[0] = $event => (($setup.sort) = $event))
            }, null, 8, ["opts", "sort"])
          ])
        ]),
        _hoisted_6,
        _createVNode($setup["Pagination"], {
          class: "row",
          "fetch-items": $setup.fetchItems,
          "use-route": "use-route",
          "emit-load": "emit-load",
          sort: $setup.sort
        }, {
          default: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_7, [
              (item.__typename == 'Post')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_router_link, {
                        class: "stretched-link text-decoration-none",
                        to: `/view/${item.id}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h5", _hoisted_10, _toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createTextVNode("by "),
                          _createVNode(_component_user_link, {
                            class: "author",
                            user: item.author
                          }, null, 8, ["user"])
                        ]),
                        _createVNode(_component_time_ago, {
                          class: "ms-auto text-muted",
                          time: item.createdat
                        }, null, 8, ["time"])
                      ])
                    ])
                  ]))
                : (item.__typename == 'HubCreation')
                  ? (_openBlock(), _createBlock($setup["CreationListingItem"], {
                      key: 1,
                      item: item
                    }, null, 8, ["item"]))
                  : (item.__typename == 'Ticket')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_router_link, {
                            class: "stretched-link text-decoration-none",
                            to: `/tracker/${item.number}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h5", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, "#" + _toDisplayString(item.number), 1),
                                _createElementVNode("span", null, _toDisplayString(item.title), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, [
                              _createTextVNode("by "),
                              _createVNode(_component_user_link, {
                                class: "author",
                                user: item.author
                              }, null, 8, ["user"])
                            ]),
                            _createVNode(_component_time_ago, {
                              class: "ms-auto text-muted",
                              time: item.createdAt
                            }, null, 8, ["time"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode($setup["TicketStatus"], { ticket: item }, null, 8, ["ticket"]),
                            _createVNode($setup["TicketKind"], {
                              class: "ms-auto",
                              kind: item.ticketKind
                            }, null, 8, ["kind"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["sort"])
      ])
    ])
  ], 64))
}